import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { ListAdherentsResponse } from '../../interfaces/adherent.interface';
import { AdherentService } from '../../services/adherent.service';
import { AgenceService } from '@/features/parametres/services/agence.service';
import { AgenceInfo } from '@/features/parametres/interfaces/agence.interface';
import { UtilisateurService } from '@/features/parametres/services/utilisateur.service';
import type { Utilisateur, UtilisateurByProfil } from '@/features/parametres/interfaces/utilisateur.interface';
import { UserRole } from '@/core/models/user.model';

/** La page vit dans l'URL : un retour sur la liste retrouve la même page et les mêmes filtres. */
export const listClientResolver: ResolveFn<ListAdherentsResponse> = (route: ActivatedRouteSnapshot) => {
  const params = route.queryParamMap;
  const page = Number(params.get('page')) || 1;
  return inject(AdherentService).getAdherents(10, page, {
    codAdh: params.get('q') ?? undefined,
    agence: params.get('agence') ?? undefined,
    gestionnaire: params.get('gestionnaire') ?? undefined,
    typePersonne: params.get('typePersonne') ?? undefined,
    emprunteur: params.get('emprunteur') ?? undefined,
  });
};

/** Options du filtre « Agence ». */
export const agencesClientResolver: ResolveFn<AgenceInfo[]> = () => inject(AgenceService).getAgencesInfos();

/** Options du filtre « Gestionnaire » : utilisateurs de profil GP uniquement. */
export const gestionnairesClientResolver: ResolveFn<UtilisateurByProfil[]> = () =>
  inject(UtilisateurService)
    .getUtilisateursByProfil(undefined, [UserRole.GestionnairePortefeuilles])
